import React from "react";
import { useSelector } from "react-redux";
import {
   BarChart,
   XAxis,
   YAxis,
   Bar,
   ResponsiveContainer,
   Tooltip,
   Legend,
} from "recharts";

const ActiveUsersChart = () => {
   const {
      dashboard: { dashboardResponse },
   } = useSelector((state) => state);
   return (
      <ResponsiveContainer width="100%" height="100%" aspect={3}>
         <BarChart
            width={750}
            height={200}
            data={
               dashboardResponse?.totalNumberOfActiveUsersGroupedByMonth ?? []
            }
         >
            <XAxis dataKey="month" />
            <YAxis tickCount={5} tick={[0, 10, 20, 30, 40]} />
            <Bar
               dataKey="userCount"
               style={{ stroke: "#fff", strokeWidth: 1 }}
               fill="#3795F4"
            />
            <Tooltip />

            <Legend />
         </BarChart>
      </ResponsiveContainer>
   );
};

export default ActiveUsersChart;
